// @owners { team: patients }
import { ALTO_COMPANY_ID } from '~shared/constants';

// FuzeRx inherits Alto's backend company (the rebrand kept company_id 1); used for analytics
// attribution only — the backend derives company from the user record.
export const getCompanyID = (): number => ALTO_COMPANY_ID;
